const SlimEpaFooter = () => {
  return (
    <footer className="footer bg-botticelli" aria-label="Site footer">
      <div className="footer__top"></div>
      <div className="footer__bottom">
        <div className="container-fluid container-t4-lg">
          <p>
            Copyright{" "}
            <a
              className="t4Edit-page"
              href="https://epaie-cms01-production.terminalfour.net/terminalfour/page/directEdit#edit/22/en/18872"
            >
              ©
            </a>{" "}
            EPA
            <span className="copyright-year"> 2022</span>
            <script type="text/javascript">
              var year = new
              Date();document.querySelector('.copyright-year').innerHTML =
              year.getFullYear();
            </script>
          </p>
        </div>
      </div>
    </footer>
  );
};

export { SlimEpaFooter };
